import { useReduxSelector } from 'hooks/store';

export default function useIsLocal() {
  const environment = useReduxSelector((state) => state.environment.REACT_APP_ENV);
  return environment === 'localhost';
}
